module.exports = __webpack_public_path__ + "static/media/Banner3.158e3536.jpg";